import React, { Component } from 'react';
import { Button, Icon, List, Container, Divider } from 'semantic-ui-react';
import { baseUrl } from "../../utils/constants";
import { AppContext } from "../../utils/context";
import request from '../../utils/request';

class SocialAccounts extends Component {
  state = {
    accounts: []
  }
  componentDidMount = async () => {
    this.getAccounts();
  }
  getAccounts = async () => {
    let accounts = await request.get(this, 'api:/social/accounts', {});
    this.setState({ accounts: accounts.data });
  }
  getCookie = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  removeToken = async (e) => {
    let id = e.target.dataset.tokenId;
    let revoke = await request.delete(this, `api:/social/accounts/${id}`, {});
    if (revoke.status === "success") {
      this.getAccounts();
    }
  }
  revokeTwitter = async () => {
    let accounts = { ...this.state.accounts }
    let revoke = await request.delete(this, `api:/social/accounts/${accounts.twitter.id}`, {});
    if (revoke.status === "success") {
      accounts.twitter = null;
      this.setState({ accounts: accounts });
    }
  }
  render() {
    const { accounts } = this.state;
    let accessToken = this.getCookie('accessToken');
    return (
      <Container text>
        <List verticalAlign='middle'>
          <List.Item>
            <List.Content floated='right'>
              <Button color='facebook' as="a" href={`${baseUrl}/login/facebook?user=${accessToken}`} >
                <Icon name='facebook' /> Login with Facebook
              </Button>
              <Button color='twitter'as="a" href={`${baseUrl}/login/twitter?user=${accessToken}`} >
                <Icon name='twitter' /> Login with Twitter
              </Button>
            </List.Content>
            <List.Content>Add Accounts</List.Content>
          </List.Item>
        </List>
        <Divider hidden />
        <List divided verticalAlign='middle'>
          {accounts.map(v => (
            <List.Item>
              <List.Content floated='right'>
                <Button color="red" content="Remove" data-token-id={v.id} onClick={this.removeToken}></Button>
              </List.Content>
              <Icon size="large" name={v.resource_type} />
              <List.Content>{v.name}</List.Content>
            </List.Item>
          ))}
        </List>
      </Container>
    );
  }
}
SocialAccounts.contextType = AppContext;


export default SocialAccounts;